import { asMultiStyleConfig } from '../../../../utils/theme';
export var Alert = asMultiStyleConfig({
  parts: ['container', 'icon'],
  baseStyle: {
    container: {
      borderRadius: '16px'
    }
  },
  colorSchemes: {
    blue: {
      container: {
        backgroundColor: 'neutral.16',
        borderColor: 'blue.400'
      },
      icon: {
        color: 'blue.600'
      }
    },
    green: {
      container: {
        borderColor: 'green.400'
      },
      icon: {
        color: 'green.400'
      }
    }
  },
  sizes: {
    sm: {
      container: {
        borderRadius: 'base'
      }
    },
    md: {
      container: {
        borderRadius: 'base'
      }
    }
  }
});